// SPEC §"Browser Support": Chromium 89+ on Windows / macOS / Linux /
// Android, or Edge 89+. Firefox + Safari are not supported. Render a
// hard banner if Web Bluetooth is missing — without it nothing works.

export function UnsupportedBrowser() {
  return (
    <div className="banner error" role="alert">
      <strong>Web Bluetooth is not available in this browser.</strong>
      <div style={{ marginTop: '0.5rem' }}>
        The Soluu test harness requires Chromium-based browsers (Chrome 89+,
        Edge 89+) on Windows, macOS, Linux, or Android. Firefox and Safari
        do not support Web Bluetooth and cannot be used for either field
        or bench testing.
      </div>
    </div>
  );
}
